import {css} from '@emotion/react';
import {fontSizes as libFontSizes} from '@recipe-ui/legacy-theme';
import merge from 'lodash/merge';
import legacyRecipeTheme from './legacyRecipeTheme';

const fontSizes = merge(libFontSizes, {
  xsmall: '0.75rem',
  small: '0.85rem',
  normal: '1rem',
  medium: '1.25rem',
  large: '1.75rem',
  xlarge: '2rem',
});

const fontFamily = `Lato, Helvetica, Arial, 'Lucida Grande', sans-serif`;
const lineHeight = '1.15';
const uppercaseText = `
  text-transform: uppercase;
  letter-spacing: 0.05em;
`;

export default css`
  body {
    color: ${legacyRecipeTheme.palette.common.black};
    font-feature-settings: 'kern', 'liga', 'pnum';
    -webkit-font-smoothing: antialiased;
  }
`;

export {fontSizes, fontFamily, lineHeight, uppercaseText};
